<div class="modal-header">
    <div class="row header-row">
        <div class="col-md-5 col-sm-12">
            <h6 class="modal-title pull-left"> <span class="back" (click)="back()"> <i class="fas fa-arrow-left"> </i>
                    &nbsp;
                    Back</span>About Us</h6>
        </div>
    </div>
</div>
<div class="modal-body">
    <div class="sect">
        <div class="title-head"> Initiatior Details</div>
        <div class="row data-info">
            <div class="col-md-4 col-sm-12"><span>Initiator Name: </span></div>
            <div class="col-md-4 col-sm-12"> <span>Organization:
                </span></div>
            <div class="col-md-4 col-sm-12"><span>Plant Name: </span></div>
        </div>
    </div>

</div>
<div>
</div>